import { GET_BOOKINGMATRIXREPORTS, GET_BOOKINGREPORTS, GET_CUSTOMERSREPORTS, GET_CUSTOMERMATRIXREPORTS,GET_REVENUEREPORTS,GET_REVENUEMATRIXREPORTS, GET_REVENUEREPORTDOWNLOAD, GET_MISREPORTS, GET_MISREPORT_COLUMNS, GET_MISREPORTSDOWNLOAD } from "resources/actionTypes";

const initialEmployeesListState = {
  loading: false,
  error: null,
  bookingMatrix: "",
};

const initialBookingReport = {
  loading: false,
  error: null,
  bookingList: "",
}

const initialCustomerReport = {
  loading: false,
  error: null,
  customerList: "",
}

const initialCustomerMatrix = {
  loading: false,
  error: null,
  customerMatrix: "",
};

const initialRevenueReport = {
  loading: false,
  error: null,
  revenueList: "",
}

const initialRevenueMatrix = {
  loading: false,
  error: null,
  revenueMatrix: "",
};

const initialDownload = {
  loading: false,
  error: null,
  downloadReport: '',
}

const initialMisReport = {
  loading: false,
  error: null,
  misList: "",
  reportColumns: [],
  reportColumnsLoading: false,
}

const initialMisReportDownload = {
  loading: false,
  error: null,
  downloadReport: '',
}

export const getBookingReportList = (state = initialBookingReport, action) => {
  switch (action.type) {
    case GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingList: action.bookingList,
      };
    case GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBookingMatrix = (state = initialEmployeesListState, action) => {
    switch (action.type) {
      case GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_SUCCESS:
        return {
          ...state,
          loading: false,
          bookingMatrix: action.bookingMatrixReports,
        };
      case GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
    }
  };

  export const getCustomerMatrix = (state = initialCustomerMatrix, action) => {
    switch (action.type) {
      case GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_REQUESTED:
        return {
          ...state,
          loading: true,
        };
      case GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_SUCCESS:
        return {
          ...state,
          loading: false,
          customerMatrix: action.customerMatrix,
        };
      case GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
      default:
        return state;
    }
  };
  
  export const getCustomerList = (state = initialCustomerReport, action) => {
      switch (action.type) {
        case GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_SUCCESS:
          return {
            ...state,
            loading: false,
            customerList: action.customerList,
          };
        case GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        default:
          return state;
      }
    };

    export const getRevenueList = (state = initialRevenueReport, action) => {
      switch (action.type) {
        case GET_REVENUEREPORTS.GET_REVENUEREPORTS_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_REVENUEREPORTS.GET_REVENUEREPORTS_SUCCESS:
          return {
            ...state,
            loading: false,
            revenueList: action.revenueList,
          };
        case GET_REVENUEREPORTS.GET_REVENUEREPORTS_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        default:
          return state;
      }
    };

    export const getRevenueMatrix = (state = initialRevenueMatrix, action) => {
      switch (action.type) {
        case GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_SUCCESS:
          return {
            ...state,
            loading: false,
            revenueMatrix: action.revenueMatrix,
          };
        case GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        default:
          return state;
      }
    };

    export const getRevenueDownLoad = (
      state = initialDownload,
      action
    ) => {
      switch (action.type) {
        case GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_SUCCESS:
          return {
            ...state,
            loading: false,
            downloadData: action.downloadReport,
          };
        case GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        default:
          return state;
      }
    }; 
    
    export const getMisList = (state = initialMisReport, action) => {
      switch (action.type) {
        case GET_MISREPORTS.GET_MISREPORTS_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_MISREPORTS.GET_MISREPORTS_SUCCESS:
          return {
            ...state,
            loading: false,
            misList: action.misList,
          };
        case GET_MISREPORTS.GET_MISREPORTS_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        case GET_MISREPORT_COLUMNS.GET_MISREPORT_COLUMNS_REQUESTED:
          return {
            ...state,
            reportColumnsLoading: true,
          };
        case GET_MISREPORT_COLUMNS.GET_MISREPORT_COLUMNS_SUCCESS:
          return {
            ...state,
            reportColumnsLoading: false,
            reportColumns: action.reportColumns,
          };
        case GET_MISREPORT_COLUMNS.GET_MISREPORT_COLUMNS_FAILED:
          return {
            ...state,
            reportColumnsLoading: false,
            error: action.message,
          };
        default:
          return state;
      }
    };


    export const getMisReportDownLoad = (
      state = initialMisReportDownload,
      action
    ) => {
      switch (action.type) {
        case GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_REQUESTED:
          return {
            ...state,
            loading: true,
          };
        case GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_SUCCESS:
          return {
            ...state,
            loading: false,
            downloadData: action.downloadReport,
          };
        case GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_FAILED:
          return {
            ...state,
            loading: false,
            error: action.message,
          };
        default:
          return state;
      }
    };
